<template>
  <div class="wrapper">
    <div class="animated fadeIn ">
      <b-row>
        <b-col cols="12">
         <b-breadcrumb :items="breadcrumbs"/>         
          <b-card header-tag="header" footer-tag="footer" style=" margin-bottom: 0px;">         
            <b-row class="boxto">     
              <b-col sm="6" lg="2">
                <b-card no-body class="bg-aqua">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-3 text-center" id="pickupassigned" v-b-tooltip.hover title="Forward Pickup">0</h4>
                    <a href="/misreport"><p class="text-center countcolor"  v-b-tooltip.hover title="Forward Pickup">Forward Pickup</p></a>
                  </b-card-body>        
                </b-card>
              </b-col>
              <b-col sm="6" lg="2">
                <b-card no-body class="bg-def" >
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-3 text-center" v-b-tooltip.hover title="Reverse Pickup" id="pickuppending">0</h4>
                    <a href="/misreport"> <p class="text-center countcolor" v-b-tooltip.hover title="Reverse Pickup">Reverse Pickup</p></a>
                  </b-card-body>        
                </b-card>
              </b-col>
               <b-col sm="6" lg="2">
                <b-card no-body class="bg-green">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-3 text-center" id="totalrto" v-b-tooltip.hover title="Return To Origin">0</h4>
                    <a href="/misreport"> <p class="text-center countcolor" v-b-tooltip.hover title="Return To Origin">Total RTO </p></a>
                  </b-card-body>        
                </b-card>
              </b-col>   
              <b-col sm="6" lg="2">
                <b-card no-body class="bg-pink">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-3 text-center" id="deliverypending" v-b-tooltip.hover title="Delivered Pending">0</h4>
                    <a href="/misreport"> <p class="text-center countcolor"  v-b-tooltip.hover title="Delivered Pending">Delivery Pending</p></a>
                  </b-card-body>        
                </b-card>
              </b-col>
              <b-col sm="6" lg="2">
                <b-card no-body class="bg-purpal">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-3 text-center" id="delivered" v-b-tooltip.hover title="Total Delivered">0</h4>
                    <a href="/misreport"> <p class="text-center countcolor" v-b-tooltip.hover title="Total Delivered">Total Delivered</p></a>
                  </b-card-body>        
                </b-card>
              </b-col>
             
              <b-col sm="6" lg="2">
                <b-card no-body class="bg-red">
                  <b-card-body class="pb-0" >          
                    <h4 class="mb-0 display-3 text-center" id="ndr" v-b-tooltip.hover title="Hand Over Pending">0</h4>
                    <a href="/misreport"> <p class="text-center countcolor" v-b-tooltip.hover title="Hand Over Pending">HandOver Pending</p></a>
                  </b-card-body>        
                </b-card>
              </b-col>
            </b-row>
            <b-row class="mt-4">     
              <b-col sm="12" lg="4">    
                <b-card>
                    <div class="text-center" ><strong>Pick Up</strong></div>
                  <PickUp_mr></PickUp_mr>
                </b-card>
              </b-col> 
              <b-col sm="12" lg="4">   
                <b-card>
                  <div class="text-center" ><strong>Delivery</strong></div>
                  <Delivery_mr></Delivery_mr>
                </b-card>
              </b-col> 
              <b-col sm="12" lg="4">   
                <b-card>
                  <div class="text-center" ><strong>Location Not Assigned</strong></div>
                  <pincodenotassigned_mr ></pincodenotassigned_mr>       
              </b-card>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
  </div>
</div>
</template>
<script>
import PickUp_mr from './pickup_mr'
import Delivery_mr from './delivery_mr'
import pincodenotassigned_mr from './pincodenotassigned_mr'
import googleMap_mr from './googlemap_mr'
export default {
  data: function () {
    return {
      name: 'dashboard',
       breadcrumbs: [{
        text: 'Dashboard',
        active: true
      }]
    }
  },
  components: {
    PickUp_mr,
    Delivery_mr,
    pincodenotassigned_mr,
    googleMap_mr,
    userInfo: []
  },
  created: function () {
  },
  methods: {}
}
</script>

<style>
.bg-aqua{
      background-color: #00c0ef !important;
      color: #fff!important;
}
.bg-green{
      background-color: #00a65a !important;
       color: #fff!important;
}
.bg-yellow{
      background-color: #f39c12 !important;
       color: #fff!important;
}
.bg-pink{
  background-color: #FF69B4 !important;
   color: #fff!important;
}
.bg-purpal{  
    background-color: #9370DB !important;
     color: #fff!important;
}
.bg-cyan{
      background-color: #008B8B !important;
       color: #fff!important;  
}
.bg-red{
      background-color: #dd4b39 !important;
       color: #fff!important;
}
.bg-def{
  background-color: #f09642 !important;
   color: #fff!important;
  
}
.boxto .card-body{
  padding: 0px!important;
}
.countcolor
{
      color:white !important;

}
.display-3 
{
      font-size: 3.5rem !important;
}

</style>